import { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import arrowleft from '../../assets/arrowleft.png';
import tablertemplate from '../../assets/tabularblue.png';
import TemplatePreview from './templatepreview';
import Saveoptions from './templatesavemodal';
import api from 'api/api';
import { Alert, Backdrop, CircularProgress, Snackbar } from '@mui/material';
import ShowPdf from './showpdf';
import useModalStore from 'zustand/zustandstore';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave } from '@fortawesome/free-solid-svg-icons';
import SideBarWrapper from 'version2/sidebarwrap';
import V2header from 'version2/v2header';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import doc from '../../assets/docwhite.png'
import downarrow from '../../assets/arrow-down.png'
import PreviewAnimation from './previewanimation';
import back from '../../assets/backarraow.png'
const ModifyTemplate = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false)
    const [openToast, setOpenToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const[isPromptUploading,setIsPromptUploading]=useState(false)
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);  // Track dropdown visibility
    const [selectedTemplate, setSelectedTemplate] = useState("");   // Store selected template
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [previousTemplateName, setPreviousTemplateName] = useState('')
    const [cards, setCards] = useState([])
    const [notedata, setNoteData] = useState('')
const promptref=useRef(false)
    const [currentpdf,setCurrentPdf]=useState('')
    const [currentuser,setCurrentuser]=useState('')

      const mydata=useModalStore()
    const { temp } = useParams();
    const [default_template, setDefaulttemplate] = useState('')
    const [inputPrompt, setInputPrompt] = useState('')
    const [savedprompt,setSavedPrompt]=useState('')
    const [saveapiprompt,setSaveApiPrompt]=useState('')
    const[selectedtempobj,setSelectedTempobj]=useState('')
    const [selectedTemplateData, setSelectedTemplateData] = useState({})
    const [pdfFile,setPdfFile]=useState('')
    const [currentbolb,setcurrentblob]=useState('')
    const[showcurrentblob,setShowCurrentBlob]=useState(false)
    const [afterblob,setafterBlob]=useState('')
    const[ShowAfterBlob,setshowAfterblob]=useState(false)
    const [severity,setSeverity]=useState('success')
    // Toggle dropdown visibility
    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };
    const handleCloseToast = () => {
        setOpenToast(false);
    };
const fetchnote=async()=>{
    const getnote = await api.get(`/v1/recording/note/${temp}/get`)
    if(getnote.status==200){
        setNoteData(getnote)
    }
    const uniqueParam = new Date().getTime(); // or use a random number: Math.random() 
   // Fetch the PDF from the server with a unique parameter to prevent caching
   const response = await api.get(`/v1/basic/documents/PDF/${getnote.data[0].audiolink}?_=${uniqueParam}`, {
     responseType: "blob", // Ensure response type is 'blob' for binary data
   });
      const pdfBlob = new Blob([response], { type: "application/pdf" });
 setCurrentPdf(pdfBlob)

}
function mergeTemplates(collectedTemplates, userTemplates) {
  const templateMap = new Map();

  // Ensure both inputs are arrays
  const collected = Array.isArray(collectedTemplates) ? collectedTemplates : [];
  const user = Array.isArray(userTemplates) ? userTemplates : [];

  // Helper to safely extract template key
  const getKey = (template) => {
    if (template && typeof template === 'object' && !Array.isArray(template)) {
      const keys = Object.keys(template);
      return keys.length === 1 ? keys[0] : null;
    }
    return null;
  };

  // Add collected templates with priority
  for (const template of collected) {
    const key = getKey(template);
    if (key) templateMap.set(key, template);
  }

  // Add user templates if not already in map
  for (const template of user) {
    const key = getKey(template);
    if (key && !templateMap.has(key)) {
      templateMap.set(key, template);
    }
  }

  return Array.from(templateMap.values());
}

// Example usage:



    const fetchdata = async () => {
        try {
            setLoading(true)
            const response = await api.get('/auth/me')
            setCurrentuser(response)
            if (response && response.templates && response.templates.default_template) {
                setDefaulttemplate(response.templates.default_template);
            }
            if (response && response.config) {
                const practiceIdString = String(response.config.practiceid);
                const departmentIdString = String(response.config.departmentid);
                const getnote = await api.get(`/v1/recording/note/${temp}/get`)

                setNoteData(getnote)
             
                // const data = await api.post('/v1/user_templates/get_all_templates', {
                //     practiceid: practiceIdString,
                //     departmentid: departmentIdString,
                // });
             
                    const user_templates=await api.get('/v1/user_templates/default_populated_templates')
                    let collectedtemplatenames=[]
                    let protemplatesdata=[]
                    // if(mydata.user_type === 'PRO'){
                    //   const protemplates=await api.get('/v1/user_templates/get_populated_templates');
                    // if(protemplates.status==200){
                    //   protemplatesdata=protemplates.file_names
                    // }
                    
                    // }
                    if(user_templates.status==200){
                      collectedtemplatenames=user_templates.file_names||[]
                    }
                    var usertemp=[]
                    if (response.templates && Array.isArray(response.templates.templates)) {
                      const transformedTemplates = response.templates.templates
                      .filter(obj => obj.template ) // Ensure required keys exist
                      .map(obj => ({
                          [obj.template]: { prompt: obj.prompt }
                      }));
                  usertemp=transformedTemplates
     
                  const templateName = getnote?.data?.[0]?.config?.template_name;
                  setPreviousTemplateName(templateName||'soap_note')
                  if (templateName && usertemp) {
                      const templateData = usertemp.find(card => card[templateName]);

                      if (templateData) {
                          setSelectedTemplateData(templateData[templateName]);
                      }
                  }
               
                  }      
               
                  setCards(mergeTemplates(collectedtemplatenames,usertemp));

               
       

            }

        } catch (error) {
            console.log(error)

        } finally {
            setLoading(false)
        }

    }
    useEffect(() => {
        fetchdata()
        fetchnote()
    }, [])
    useEffect(() => {
if(mydata.usertype!=='PRO'&&mydata.usertype!=='PLUS'){
  return
}

      if (!selectedTemplate && !previousTemplateName) return;    
      const templatesList = currentuser?.templates?.templates || [];

      // Find selected or previous template
      const selectedMatch = templatesList.find(t => t?.template === selectedTemplate);

      const previousMatch = selectedMatch ? null : templatesList.find(t => t?.template === previousTemplateName);
      const matchedTemplate = selectedMatch || previousMatch;
  
      // Safely get prompt based on whether section exists
      const promptValue = matchedTemplate?.sections
        ? (matchedTemplate?.post_processing_prompt ?? '')
        : (matchedTemplate?.instructions ?? '');
      
      setInputPrompt(promptValue);
      setSavedPrompt(promptValue)
      setSaveApiPrompt(matchedTemplate?.prompt||'')
      if(matchedTemplate?.sections){
        promptref.current=true
        setSelectedTempobj(matchedTemplate?.sections||[])
      }else{
        promptref.current=false
      
      }
    }, [currentuser, selectedTemplate, previousTemplateName]);


    // Handle template selection
    const handleTemplateSelect = (template) => {
        setSelectedTemplate(template);
        setIsDropdownOpen(false);  // Close dropdown after selecting
    };
    const closeModal = () => setIsModalOpen(false);
  
    const handleApply = async () => {
       
        setIsPromptUploading(true)
        try {
          let obj={
            
            "category": "all",
            "file_name": notedata.data[0].audiolink,
        
          }
          if(selectedTemplate=='No Template'||promptref.current){
obj.comments=inputPrompt
          }else{

obj.template_prompt=inputPrompt
          }
          if((selectedTemplate||previousTemplateName)&&(selectedTemplate!=='No Template'&&previousTemplateName !=='No Template')){
            obj.template_name=selectedTemplate||previousTemplateName
          }
const response = await api.put('/v1/document/post-processing',obj)
  if(response.status===200){

setToastMessage('Applied successfully!');
setSeverity("success")
setOpenToast(true)
await fetchnote()
  }else{



  }
        } catch (error) {
console.log(error)

setToastMessage('Something went wrong!');
setSeverity("error")
setOpenToast(true)
        } finally {
setIsPromptUploading(false)

        }



    }
    const handleButton=()=>{
        handleApply()
    }
    const saveModification=async()=>{
        setLoading(true)
try {

    const response=await api.put('/v1/document/save/post-processing',{
        "file_name": notedata?.data?.[0]?.config?.post_processing_docuemnt_name
      })
      if(response.status==200){
        setSeverity("success")
        setToastMessage('Submitted successfully!');
        setOpenToast(true)
      }
      await fetchnote()
} catch (error) {
    
}finally{
setLoading(false)


}

    }

const saveprompt=async()=>{
  try {
    setLoading(true)
    let response;
    if(promptref.current){
   response =await api.put(`/v1/user/set-template-prompt`,{
       "tempalte_name": selectedTemplate||previousTemplateName,
  "prompt": inputPrompt
    })
    }else{

  let obj={
      
      "template_name": selectedTemplate||previousTemplateName,
      "user_instructions":inputPrompt,
     "template_prompt":saveapiprompt,
      }
      if (
        obj.template_name === 'soap_note' ||
        obj.template_name === 'HnP' ||
        obj.template_name === 'soap_note_combined'
      ) {
        obj.default_template = 'true'
        obj.template_prompt=""
      }
       response=await api.post('/v1/user_templates/save_template',obj)
    }
  
  
    if(response.status==200){
      setSeverity("success")
      setToastMessage(response.message);
      setOpenToast(true)
    }
  } catch (error) {
    console.log(error)
  }finally{
setLoading(false)
  }
}


    const handlecurrentblob = async () => {
        try {
           // Trigger loading spinner
           setLoading(true); 
           const uniqueParam = new Date().getTime(); // or use a random number: Math.random() 
         // Fetch the PDF from the server with a unique parameter to prevent caching
         const response = await api.get(`/v1/basic/documents/PDF/${notedata?.data[0].audiolink}?_=${uniqueParam}`, {
           responseType: "blob", // Ensure response type is 'blob' for binary data
         });
            const pdfBlob = new Blob([response], { type: "application/pdf" });
       
           // Generate a URL for the Blob
           const pdfUrl = URL.createObjectURL(pdfBlob);
       setcurrentblob(pdfBlob)
       setShowCurrentBlob(true)
           // Open the generated URL in a new tab
           //window.open(pdfUrl, "_blank");
       
         } catch (error) {
           console.error("Error fetching the PDF:", error);
         } finally {
           // Turn off loading spinner
           setLoading(false);
          
         }
       };
       const handleAfterblob = async () => {
        try {
           // Trigger loading spinner
           setLoading(true); 
           const uniqueParam = new Date().getTime(); // or use a random number: Math.random() 
         // Fetch the PDF from the server with a unique parameter to prevent caching
         const response = await api.get(`/v1/post-processing/documents/PDF/${notedata?.data?.[0]?.config?.post_processing_docuemnt_name}`, {
           responseType: "blob", // Ensure response type is 'blob' for binary data
         });
            const pdfBlob = new Blob([response], { type: "application/pdf" });
       
           // Generate a URL for the Blob
           const pdfUrl = URL.createObjectURL(pdfBlob);
       setafterBlob(pdfBlob)
       setshowAfterblob(true)
           // Open the generated URL in a new tab
           //window.open(pdfUrl, "_blank");
       
         } catch (error) {
           console.error("Error fetching the PDF:", error);
         } finally {
           // Turn off loading spinner
           setLoading(false);
          
         }
       };
       const getDisplayName = (key) => {
        return key === "HnP"
            ? "History & Physical"
            : key === "soap_note"
            ? "Soap Note"
            : key;
    };
    return (
        <>

          <V2header/>
   
                   <div className="flex items-center justify-center w-full h-auto">
                <div className="flex flex-col  gap-2  w-full  min-h-[85vh] h-auto p-8  rounded-[4px] ">
                    {/* <div onClick={() => navigate(-1)} className="flex items-start cursor-pointer">
                        <img src={arrowleft} alt="Back Arrow" className="w-4 h-4" />
                    </div> */}
                    <div className='w-full flex flex-wrap gap-4 sm:gap-0 justify-center sm:justify-between items-center'>
<div className="text-start relative flex items-center  sm:gap-4 text-xl text-[#000] font-semibold">
<div onClick={()=>navigate(-1)} className="cursor-pointer absolute left-[-30%] sm:left-0">
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
  <g clip-path="url(#clip0_7403_35126)">
    <path d="M22 11.6875H2.68555L11.1396 20.1416L10.1729 21.1084L0.0644531 11L10.1729 0.891602L11.1396 1.8584L2.68555 10.3125H22V11.6875Z" fill="black"/>
  </g>
  <defs>
    <clipPath id="clip0_7403_35126">
      <rect width="22" height="22" fill="white"/>
    </clipPath>
  </defs>
</svg>
      </div>

 <span className='sm:ml-8'>
  Advanced Editing
  </span> 
                    </div>
<div className=' w-auto flex gap-8 items-center justify-center'>

<div className='relative '>
<div
                            onClick={toggleDropdown}
                            className="inline-flex items-center justify-between w-[200px] cursor-pointer  h-10 p-2 rounded-md border border-gray-100 bg-white shadow-[0px_4px_16px_0px_rgba(20,25,26,0.08)]"
                        >
                           <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
  <path d="M14.1134 2H3.4467C3.07851 2 2.78003 2.29848 2.78003 2.66667V6C2.78003 6.36819 3.07851 6.66667 3.4467 6.66667H14.1134C14.4816 6.66667 14.78 6.36819 14.78 6V2.66667C14.78 2.29848 14.4816 2 14.1134 2Z" stroke="#3B82F6" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M8.11336 9.3335H3.4467C3.07851 9.3335 2.78003 9.63197 2.78003 10.0002V13.3335C2.78003 13.7017 3.07851 14.0002 3.4467 14.0002H8.11336C8.48155 14.0002 8.78003 13.7017 8.78003 13.3335V10.0002C8.78003 9.63197 8.48155 9.3335 8.11336 9.3335Z" stroke="#3B82F6" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M14.1133 9.3335H12.1133C11.7451 9.3335 11.4467 9.63197 11.4467 10.0002V13.3335C11.4467 13.7017 11.7451 14.0002 12.1133 14.0002H14.1133C14.4815 14.0002 14.78 13.7017 14.78 13.3335V10.0002C14.78 9.63197 14.4815 9.3335 14.1133 9.3335Z" stroke="#3B82F6" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
                            <div className='text-sm font-normal'>
    {selectedTemplate 
        ? getDisplayName(selectedTemplate) 
        : previousTemplateName 
        ? getDisplayName(previousTemplateName) 
        : "Choose Template"}
        
</div> <KeyboardArrowDownIcon style={{color:""}}/>
                        </div>
                           {/* Dropdown Menu */}
                           {isDropdownOpen && !loading && (
                          <div className="absolute max-h-56 overflow-y-auto  left-[1%] top-[32%] mt-6  custom-scrollbar bg-white border border-gray-300 rounded-md shadow-md w-40 sm:w-48 z-10">
                          <ul className="list-none p-2">
                          {cards?.map((card, index) => {
    const documentKey = Object.keys(card)[0];
    const documentData = card[previousTemplateName];
    const displayName =
        documentKey === "HnP"
            ? "History & Physical"
            : documentKey === "soap_note"
            ? "Soap Note"
            : documentKey;

    return (
        <li
            key={index}
            className={`p-2 cursor-pointer text-start text-xs truncate ${
                documentKey === previousTemplateName ? 'bg-gray-100' : ''
            } hover:bg-gray-100`}
            onClick={() => handleTemplateSelect(documentKey)}
            title={displayName}
        >
            {displayName}
        </li>
    );
})}

{/* Render "No Template" only if not already present */}
{!cards?.some(card => Object.keys(card)[0] === 'No Template') && (
    <li
        className={`p-2 cursor-pointer text-start text-xs truncate ${
            previousTemplateName === 'No Template' ? 'bg-gray-100' : ''
        } hover:bg-gray-100`}
        onClick={() => handleTemplateSelect('No Template')}
        title='No Template'
    >
        No Template
    </li>
)}

                          </ul>
                      </div>
                      
                        )}

</div>




</div>


                    </div>
                    
                    <div className="flex flex-col  w-full gap-4 items-center justify-center ">
                   
                        {/* <div className="flex flex-col items-start ml-4 flex-grow"> */}
                 
                        
                     
<div className='w-full mt-8'> 
    <div className='text-sm  w-full  text-start font-medium mb-2'>Template Instructions</div>
                           <div className='relative'>
                           <textarea
  onChange={(e) => setInputPrompt(e.target.value)}
  value={inputPrompt}
  className="w-full p-3 border border-gray-300 rounded-md shadow-sm"
  placeholder={
    promptref.current
      ? `Instructions

Use [primary_source] as the main reference. Include information from [supplemental_source] only when needed.

Follow the layout provided in [structure_guide]. Fill each section with relevant content and exclude unrelated details.

`
      : "Instructions to modify the template - Example: 'Give me a more detailed HPI'"
  }
  rows={
    promptref.current
      ? 6
      : Math.min(Math.max(inputPrompt.split('\n').length, 3), 9)
  }

></textarea>

                       {(mydata.usertype==='PRO'||mydata.usertype=='PLUS')&&notedata?.data?.[0]?.config?.temp_note_json ? <FontAwesomeIcon
        icon={faSave}
        className="absolute top-[80%] left-[93%] sm:left-[98%] text-green-600 cursor-pointer"
        onClick={() => saveprompt()}
          title="Save this prompt for further use"
      />:<></>}

                           </div>
                           <div>
                           <div className='text-start text-xs'>
  {promptref.current && selectedtempobj.length > 0 && (
    <span style={{ color: 'red' }}>
           Note: Changes will be applied only to the {' '}
      {selectedtempobj.map((obj, index) => (
        <span key={index}>
          {obj.section_name}
          {index < selectedtempobj.length - 1 ? ', ' : ''}
        </span>
      ))}
    </span>
  )}
</div>

</div>

      
                        {/* </div> */}</div>
                    </div>

                    {/* Preview Button */}
                    <div className='flex items-center gap-4 justify-center mt-4'>
                    <button
  onClick={() => handleButton()}
  disabled={
    (selectedTemplate === 'No Template' && !inputPrompt) ||(!selectedTemplate&&!previousTemplateName)||
    (!inputPrompt && selectedTemplate === previousTemplateName) ||
    isPromptUploading
  }
  className={`px-12 py-2 rounded-md font-[Tahoma] text-xs ${
    (!(
      (selectedTemplate === 'No Template' && !inputPrompt) ||(!selectedTemplate&&!previousTemplateName)||
      (!inputPrompt && selectedTemplate === previousTemplateName) ||
      isPromptUploading
    ))
      ? 'bg-[#2563EB] text-white'
      : 'bg-gray-400 text-gray-700 cursor-not-allowed'
  }`}
>
{isPromptUploading
  ? 'Applying'
  : (inputPrompt?.trim() === ''||(!selectedTemplate&&!previousTemplateName))
    ? 'Change Template'
    : 'Apply Instructions'}

</button>

                     
  <div>

{notedata?.data?.[0]?.config?.temp_note_json ? (
<button
 onClick={() => saveModification()}
 disabled={!notedata?.data?.[0]?.config?.temp_note_json}
 className={`px-12 py-2 rounded-md font-[Tahoma] text-xs font-medium flex items-center justify-center  ${
   notedata?.data?.[0]?.config?.temp_note_json
     ? 'bg-[#2563EB] text-white'
     : 'bg-gray-400 text-gray-700 cursor-not-allowed'
 }`}
>
 {/* <img src={doc} alt="" className='w-4 h-4' /> Save Template */}Apply Template
</button>
) : null} 
</div>

                    </div>

                    {/* Before and After Previews */}
                    <div className="w-full flex items-center justify-center mt-4 flex-wrap gap-4">
  {/* Current PDF Section */}
  <div
    className={`w-full sm:w-[45%] flex items-center justify-center flex-col`}
  >
    <div className="text-sm text-center  font-medium mb-2">Before</div>
    <button
      onClick={() => handlecurrentblob()}
      className="flex items-center w-[100px] mb-2 justify-center gap-2 p-2 h-10 text-white text-xs font-semibold rounded-lg bg-[#1C2A3A]"
    >
      Preview
    </button>
    {notedata?.data?.[0]?.note_json ? (
      <TemplatePreview data={notedata?.data?.[0]?.note_json} />
    ) : null}
  </div>


  {(notedata?.data?.[0]?.config?.temp_note_json) ? (
    <div
      className={`w-full ${
        notedata?.data?.[0]?.note_json ? "sm:w-[45%]" : "w-full"
      } flex flex-col justify-center items-center`}
    >
      <div className="text-sm text-center font-medium mb-2">After</div>

      <button
        onClick={() => handleAfterblob()}
        className="flex items-center w-[100px] mb-2 justify-center gap-2 p-2 h-10 text-white text-xs font-semibold rounded-lg bg-[#1C2A3A]"
      >
        Preview
      </button>
      <TemplatePreview data={notedata?.data?.[0]?.config?.temp_note_json} />
    </div>
  ):<>
<div
   className='w-full sm:w-[45%] flex flex-col justify-center items-center'
    >
      <div className="text-sm h-4  text-center font-medium mb-2">
        
      </div>

      <button
 
        className="flex items-center w-[100px] mb-2 justify-center gap-2 p-2 h-10"
      >
       
      </button>
      <PreviewAnimation status={isPromptUploading}/>
      </div>
  
  </>}
</div>

                </div>
            </div>
            <ShowPdf ispdfshow={showcurrentblob} setIspdfShow={setShowCurrentBlob} pdfBlob={currentbolb}/>
            <ShowPdf ispdfshow={ShowAfterBlob} setIspdfShow={setshowAfterblob} pdfBlob={afterblob}/>
            {isModalOpen ? <Saveoptions closeModal={closeModal} /> : <></>}
            <Snackbar
    open={openToast}
    autoHideDuration={6000}
    onClose={handleCloseToast}
    anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
    }}
>
    <Alert
        onClose={handleCloseToast} 
        severity={severity} // Can be 'error', 'warning', 'info', or 'success'
        sx={{ width: '100%' }}
    >
        {toastMessage}
    </Alert>
</Snackbar>


            <Backdrop
                sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loading}
            >
                <CircularProgress color="inherit" size={40} />
            </Backdrop>


        </>
    );
};

export default ModifyTemplate;
